var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "appStyle" } },
    [
      _c(
        "el-timeline",
        { attrs: { reverse: true } },
        _vm._l(_vm.timeLineData, function (item, key) {
          return _c(
            "el-timeline-item",
            {
              key: key,
              attrs: { placement: "top", color: _vm.colorArr[key % 4] },
            },
            [
              _c("div", { staticClass: "leftStyle" }, [
                _c("div", [
                  _c("div", [_vm._v("登记人：" + _vm._s(item.createdBy))]),
                ]),
                _c("div", { staticStyle: { "margin-top": "8px" } }, [
                  _c("div", [_vm._v("登记时间：" + _vm._s(item.createdTime))]),
                ]),
              ]),
              _c(
                "div",
                { staticStyle: { "margin-top": "-20px" } },
                [
                  _c("el-card", { staticStyle: { width: "50%" } }, [
                    _c("div", { staticStyle: { display: "flex" } }, [
                      _c("div", { staticStyle: { "margin-right": "10px" } }, [
                        _vm._v("完好：" + _vm._s(item.intact || 0)),
                      ]),
                      _c("div", { staticStyle: { "margin-right": "10px" } }, [
                        _vm._v("破损：" + _vm._s(item.damaged || 0)),
                      ]),
                      _c("div", [
                        _vm._v("漏件：" + _vm._s(item.missingParts || 0)),
                      ]),
                    ]),
                    _c("div", { staticStyle: { display: "flex" } }, [
                      _c("div", { staticStyle: { "margin-right": "20px" } }, [
                        _vm._v(
                          "是否理赔：" + _vm._s(item.claimFlagLabel || "--")
                        ),
                      ]),
                      _c("div", { staticStyle: { "margin-right": "10px" } }, [
                        _vm._v("理赔金额：" + _vm._s(item.claimAmount || 0)),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
            ]
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }